import React from 'react'
import {
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Button,
    Typography,
} from '@material-ui/core'

interface FhaAckDialogProps {
    open: boolean
    title: string
    body: string
    confirmLabel: string
    onClose: () => void
    onConfirm: () => void
}

export const FhaAckDialog: React.FC<FhaAckDialogProps> = ({
    open,
    title,
    body,
    confirmLabel,
    onClose,
    onConfirm,
}) => {
    const [acknowledged, setAcknowledged] = React.useState(false)

    React.useEffect(() => {
        if (open) setAcknowledged(false)
    }, [open])

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Typography variant="body2" paragraph>
                    {body}
                </Typography>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={acknowledged}
                            onChange={(e) => setAcknowledged(e.target.checked)}
                            color="primary"
                        />
                    }
                    label="I understand this setting is for roommate assignment only and must not be used to deny housing or change terms."
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    color="primary"
                    variant="contained"
                    disabled={!acknowledged}
                    onClick={onConfirm}
                >
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
